import { NavigationGuard } from 'vue-router';
import { isOn } from '@/lib/growthbook';

const corporateVerificationGuard: NavigationGuard = (_to, _from, next) => {
  if (isOn('sc-automate-corporate-upgrades-enabled')) {
    next();
    return;
  }

  next('/account/seekers/dashboard');
};

export default corporateVerificationGuard;
